(function () {
  var root = document.querySelector('.lm');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  /* Kaart vult het scherm onder de header */
  function setHeader() {
    var h = document.querySelector('.section-header');
    if (h) root.style.setProperty('--lm-header', h.getBoundingClientRect().height + 'px');
  }
  setHeader();
  window.addEventListener('resize', setHeader);

  /* Tags: utm_content uit de link wordt een extra tag (bio-a, bio-b, ...) */
  var tagInput = root.querySelector('[data-lm-tags]');
  if (tagInput) {
    var extra = '';
    try {
      var q = new URLSearchParams(location.search);
      extra = (q.get('utm_content') || q.get('bron') || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 30);
      if (extra) sessionStorage.setItem('lm-tag', extra);
      else extra = sessionStorage.getItem('lm-tag') || '';
    } catch (e) {}
    if (extra) tagInput.value = tagInput.value + ', ' + extra;
  }

  /* Fotospoor */
  var trail = root.querySelector('.lm-trail');
  var list = [];
  try { list = JSON.parse(trail.getAttribute('data-photos')) || []; } catch (e) {}
  if (!list.length) return;

  for (var s = list.length - 1; s > 0; s--) {
    var j = Math.floor(Math.random() * (s + 1));
    var t = list[s]; list[s] = list[j]; list[j] = t;
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var done = !!root.querySelector('[data-lm-done]');

  var ready = [];
  function load(src) {
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { ready.push(src); };
    im.src = src;
  }
  list.slice(0, 10).forEach(load);
  function loadRest() { list.slice(10).forEach(load); }
  if (document.readyState === 'complete') setTimeout(loadRest, 300);
  else window.addEventListener('load', function () { setTimeout(loadRest, 300); });

  var POOL = 18, pool = [], pi = 0, ri = 0, z = 1;
  for (var k = 0; k < POOL; k++) {
    var el = document.createElement('img');
    el.alt = '';
    el.decoding = 'async';
    el.draggable = false;
    trail.appendChild(el);
    pool.push(el);
  }

  function place(x, y, opts) {
    if (!ready.length) return;
    opts = opts || {};
    var img = pool[pi];
    pi = (pi + 1) % POOL;
    img.src = ready[ri % ready.length];
    ri++;
    img.style.zIndex = z++;
    var rot = (Math.random() * 24 - 12).toFixed(1);
    var base = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translate(-50%,-50%) rotate(' + rot + 'deg)';
    img.getAnimations().forEach(function (a) { a.cancel(); });
    if (opts.still) {
      img.style.opacity = 1;
      img.style.transform = base;
      return;
    }
    var dx = opts.dx || 0, dy = opts.dy || 0;
    var end = 'translate(' + (x + dx).toFixed(1) + 'px,' + (y + dy + 10).toFixed(1) + 'px) translate(-50%,-50%) rotate(' + rot + 'deg)';
    img.animate(
      [
        { opacity: 0, transform: base + ' scale(0.4)' },
        { opacity: 1, transform: base + ' scale(1)', offset: 0.18 },
        { opacity: 1, transform: base + ' scale(1)', offset: 0.55 },
        { opacity: 0, transform: end + ' scale(0.9)' }
      ],
      { duration: opts.duration || (coarse ? 1500 : 1100), easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
    );
  }

  var lastX = null, lastY = null, GAP = coarse ? 58 : 80, band = 0;
  function onMove(cx, cy) {
    var r = root.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var x = cx - r.left, y = cy - r.top;
    if (x < 0 || y < 0 || x > r.width || y > r.height) return;
    if (lastX === null) { lastX = x; lastY = y; place(x, y); return; }
    var dx = x - lastX, dy = y - lastY;
    var g = coarse && band > 60 ? 34 : GAP;
    if (dx * dx + dy * dy >= g * g) { lastX = x; lastY = y; place(x, y); }
  }

  /* Rustig scherm: foto's liggen verspreid langs de randen, zonder beweging */
  if (reduce) {
    var spots = [[0.1, 0.18, 0], [0.9, 0.2, 0], [0.07, 0.72, 0], [0.93, 0.7, 0], [0.26, 0.08, 0], [0.74, 0.9, 0], [0.22, 0.9, 0], [0.78, 0.1, 0]];
    var tries = 0;
    (function scatter() {
      if (ready.length < spots.length && tries++ < 40) { setTimeout(scatter, 150); return; }
      var r = root.getBoundingClientRect();
      spots.forEach(function (p) { place(r.width * p[0], r.height * p[1], { still: true }); });
    })();
    return;
  }

  /* Vanzelf dwalen als niemand beweegt */
  var visible = true, ambientOn = false, idle = null, paused = false;
  var card = root.querySelector('.lm-card');
  function measureBand() { band = card ? card.getBoundingClientRect().top - root.getBoundingClientRect().top : 0; }
  measureBand();
  window.addEventListener('resize', measureBand);
  function ambient(now) {
    if (!ambientOn) return;
    if (visible && !paused && !document.hidden) {
      var r = root.getBoundingClientRect();
      var cx = r.left + r.width * 0.5, cy = r.top + r.height * 0.48;
      var ax = r.width * 0.42, ay = r.height * 0.36;
      /* Telefoon: de kaart vult bijna alles, dus dwalen in de vrije strook erboven */
      var tt = now;
      if (coarse && band > 60) { cy = r.top + band * 0.5; ay = band * 0.3; ax = r.width * 0.4; tt = now * 1.7; }
      var x = cx + ax * (0.7 * Math.sin(tt * 0.0011) + 0.3 * Math.sin(tt * 0.00041 + 1.7));
      var y = cy + ay * (0.7 * Math.sin(tt * 0.00087 + 0.6) + 0.3 * Math.cos(tt * 0.00033));
      onMove(x, y);
    }
    requestAnimationFrame(ambient);
  }
  function startAmbient() { if (ambientOn) return; ambientOn = true; lastX = null; measureBand(); requestAnimationFrame(ambient); }
  function stopAmbient() { ambientOn = false; }
  function resumeLater() { clearTimeout(idle); idle = setTimeout(startAmbient, 2400); }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(root);
  }

  /* Even rust in het spoor zolang je je e-mailadres typt */
  root.addEventListener('focusin', function (e) { if (e.target.tagName === 'INPUT') paused = true; });
  root.addEventListener('focusout', function () { paused = false; });

  document.addEventListener('pointermove', function (e) {
    if (coarse || e.pointerType === 'touch') return;
    stopAmbient();
    onMove(e.clientX, e.clientY);
    resumeLater();
  }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var tt = e.touches[0]; if (!tt) return;
    stopAmbient(); lastX = null; onMove(tt.clientX, tt.clientY);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    var tt = e.touches[0]; if (!tt) return;
    stopAmbient(); onMove(tt.clientX, tt.clientY);
  }, { passive: true });
  document.addEventListener('touchend', resumeLater, { passive: true });

  /* Binnenkomst: een snelle zigzag over het scherm, of na inschrijven een krans van flessen */
  function intro() {
    var start = performance.now(), DUR = 1500;
    (function step(now) {
      var p = (now - start) / DUR;
      if (p >= 1) { startAmbient(); return; }
      var r = root.getBoundingClientRect();
      onMove(r.left + r.width * (0.5 + 0.46 * Math.sin(p * Math.PI * 6)), r.top + r.height * (0.06 + 0.86 * p));
      requestAnimationFrame(step);
    })(start);
  }
  function burst() {
    var r = root.getBoundingClientRect();
    var card = root.querySelector('.lm-card').getBoundingClientRect();
    var cx = card.left - r.left + card.width / 2, cy = card.top - r.top + card.height / 2;
    var rx = Math.min(card.width / 2 + 70, r.width / 2 - 30), ry = card.height / 2 + 60, n = 14;
    for (var b = 0; b < n; b++) {
      (function (b) {
        setTimeout(function () {
          var a = (b / n) * Math.PI * 2 - Math.PI / 2;
          place(cx + Math.cos(a) * rx, cy + Math.sin(a) * ry, { duration: 2200, dx: Math.cos(a) * 60, dy: Math.sin(a) * 60 });
        }, b * 45);
      })(b);
    }
    setTimeout(startAmbient, 2400);
  }

  var waited = 0;
  (function go() {
    if (ready.length < 6 && waited++ < 20) { setTimeout(go, 100); return; }
    if (done) burst(); else intro();
  })();
})();
